import React from 'react'
import {Row,Col} from 'reactstrap'
import Tex from '../components/Tex'
export default class Choice extends React.Component{
	render(){
		var {cID, correct, select ,ans, ctext }=this.props
		var mark=cID;
		let selectedClass='';
		if(correct === null){  //not evaluated
	  		if(select===cID) {
	  			selectedClass = 'bg-secondary'; // selected
	  		}
		}
		else{ //Let's evaluate
		 	if (cID === ans ) {
				mark='O';  //Correct answer
				selectedClass='bg-info';
			}
			else if (cID === select ){ //incorrect selection
				mark='X'; //
				selectedClass='bg-danger';
			}
		}
		return(
			<Row className={selectedClass} sx="12" onClick={ correct===null ? ()=>this.props.selectChoice(): ()=>{} }>
			    <Col><p><strong>{mark+' ) '}</strong><Tex bind={ctext}/></p></Col>
			</Row>
			)
	}
}
/*
		return(
			<Row key={cID}  className={selectedClass} onClick={ correct === null ? ()=>this.props.selectChoice() : ()=>{ } }>
			    <p><strong>{mark+' ) '}</strong><Tex bind={ctext}/></p>
			</Row>
			)
*/



// WEBPACK FOOTER //
// ./src/components/Choice.js